/**
 * *This function gets a parent url if the page is inside an iframe
 * @returns String representing the parent url, if the page isn't in iframe or if the url is already in localstorage,
 * returns an empty string
 */

export default function getParentWindowUrl(): string {
  const iframeParentKey = "iframeParent";
  const parentUrl = document.location.ancestorOrigins?.[0];
  const savedParentWindowUrl = localStorage.getItem(iframeParentKey);

  if (savedParentWindowUrl === parentUrl) {
    return "";
  }

  if (parentUrl) {
    localStorage.setItem(iframeParentKey, parentUrl);
    return parentUrl;
  }

  localStorage.removeItem(iframeParentKey);
  return "";
}
